import BaseEvent from './base_event';
import * as effects from '../effects'
import MadJenkins from '../../objects/items/moveable/mad_jankins';

export default class EmiStormEvent extends BaseEvent {

    static canOccur(gameState) {
        return !gameState.eventsResults.emi_storm;
    }

    enter(gameState) {
        gameState.eventsResults.emi_storm = true;
        this.ui.showDialog({
            message: `You hear cracks and start to smell ozone. Space thunderstorm right ahead! Stormy weather is bad for your electronics and for your hair. What’s your orders, captain?`,
            options: [{
                text: `Quick, shunt the* shield’s* protonic grounding to furnace isoid capacitors!`,
                condition: gameState.has('shield'),
                callback: () => {
                    gameState.appendEnergy(50);
                    gameState.history.push({ id: 'emi', msg: 'demonstrated a solid knowledge of shield physics'});
                    this.ui.showDialog({
                        message: `Even though you have no idea what isoid capacitors are, you still manage to throw the thick wire between your shields and the furnace, giving your power storage a big boost of space electricity free of charge.`,
                        status: "+50% Energy"
                    }, this.end);
                }
            }, {
                text: `(Prepares a metal rod and handheld powerbank) Let’s catch us some battery juice!.`,
                callback: () => {
                    let dice_roll = game.rnd.frac();

                    if (dice_roll < 0.2) {
                        gameState.appendEnergy(30);
                        gameState.history.push({ id: 'emi', msg: 'was stupid beyound reason, but very lucky'});
                        this.ui.showDialog({
                            message: `You open the porthole and stick the rod outside. With a struck of lighting your powerbank gets charged to max instantly! That.. shouldn’t have worked, but it did. Never try this again though. 
                        Seriously.`,
                            status: "+30% Energy"
                        }, this.end);
                    } else if (dice_roll < 0.3) {
                        gameState.history.push({ id: 'emi', msg: 'impressed the Speed Force with his stupidity'});
                        this.ui.showDialog({
                            message: `You open the porthole and stick the rod outside. BAM! You are zapped so hard that your nerves got SUPERCHARGED! I think coffee machine could go to furnace now.`,
                            status: `Thunderstruck:\n Walk speed doubled`
                        }, () => {
                            gameState.hero.addFactor(1.8);//speed = gameState.hero.speed * 1.8;
                            this.end();
                        });
                    } else {
                        gameState.setEnergy(0);
                        gameState.history.push({ id: 'emi', msg: 'fried his brains in a space storm'});
                        this.ui.showDialog({
                            message: `You open the porthole and stick the rod outside. Then you see the light. Then it all goes dark. Then you awake, several hours later, and think for a while what a stupid idea that was.`,
                            status: "Energy drained"
                        }, this.end);
                    }
                }
            }, {
                text: `Buckle up. We’ll try to pass it quickly.`,
                callback: () => {
                    let dice_roll = game.rnd.frac();

                    let availableElectronicItems = [];
                    gameState.items.forEachStanding(o => {
                        if (o.constructor.electronic) availableElectronicItems.push(o);
                    });
                    let itemToExplode = game.rnd.pick(availableElectronicItems);
                    let jenkins = gameState.findFirstAvailable('jenkins');
                    if (dice_roll < 0.4 && jenkins) {
                        this.ui.showDialog({
                            message: `You pass the thunderstorm as quick as you can, and finally relax in a pilot seat, only to hear a faint sparkle, and see a shadow of your janitor robot looming over you. INTEGER OVERFLOW, it booms. SANITY UNDEFINED. PREPARE FOR PAIN... PREPARE FOR PAIN... PREPARE FOR PAINTING WALLS`
                        }, () => {
                            gameState.items.add(new MadJenkins(jenkins.x, jenkins.y));
                            gameState.items.removeItem(jenkins);
                            this.end();
                        });
                    } else if (itemToExplode && dice_roll < 0.8) {
                        let label = itemToExplode.constructor.label;
                        gameState.history.push({ id: 'emi', msg: `voided ${itemToExplode.constructor.label} warranty with an EMI burst`});
                        this.ui.showDialog({
                            message: `You pass the thunderstorm as quick as you can, and finally relax in a pilot seat, only to hear a loud bang. All this electronic interference caused *` + label + `* to explode. Good lord, what a mess.`
                        }, () => {
                            effects.createSparkRandom(itemToExplode.x, itemToExplode.y);
                            effects.createExplosion(itemToExplode.x, itemToExplode.y);
                            gameState.items.removeItem(itemToExplode);
                            this.end();
                        });
                    } else {
                        this.ui.showDialog({
                            message: `You skim through the storm with a little trouble. Who said giant space lightnings are scary?`
                        }, this.end);
                    }
                }
            }]
        });
    }


}



// WEBPACK FOOTER //
// ./src/states/events/emi_storm.js